export const removeItem = (arr, item) => arr.filter((x) => x !== item);
